import { render, staticRenderFns } from "./CardVenda.vue?vue&type=template&id=0fce7e9d&scoped=true&"
import script from "./CardVenda.vue?vue&type=script&lang=js&"
export * from "./CardVenda.vue?vue&type=script&lang=js&"
import style0 from "./CardVenda.vue?vue&type=style&index=0&id=0fce7e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce7e9d",
  null
  
)

export default component.exports